import { logger } from "@/utils/logger";
// Debug logging utility for OpenAI API calls
export const debugLogger = {
  // Clear previous debug data and log new API call payload
  logApiCall: (payload: any) => {
    // Clear previous debug data
    sessionStorage.removeItem('openai-debug-payload');
    sessionStorage.removeItem('openai-debug-response');
    sessionStorage.removeItem('openai-debug-error');
    
    // Log new API call payload
    sessionStorage.setItem('openai-debug-payload', JSON.stringify(payload));
    sessionStorage.setItem('openai-debug-timestamp', new Date().toISOString());
    
    logger.log('🐛 Debug: API call captured (see Debug Modal)');
  },

  // Log API response
  logApiResponse: (response: any) => {
    sessionStorage.setItem('openai-debug-response', JSON.stringify(response));
    logger.log('🐛 Debug: API response captured (see Debug Modal)');
  },

  // Log API error with robust serialization
  logApiError: (error: any) => {
    let normalized: any;
    if (error instanceof Error) {
      normalized = { name: error.name, message: error.message, stack: error.stack };
    } else if (typeof error === 'string') {
      normalized = { message: error };
    } else if (error && typeof error === 'object') {
      try {
        // Convert non-serializable objects safely
        normalized = JSON.parse(JSON.stringify(error));
        if (Object.keys(normalized).length === 0) {
          normalized = { message: String(error) };
        }
      } catch (_) {
        normalized = { message: String(error) };
      }
    } else {
      normalized = { message: String(error) };
    }

    sessionStorage.setItem('openai-debug-error', JSON.stringify(normalized));
    logger.log('🐛 Debug: API error captured (see Debug Modal)');
  },

  // Clear all debug data
  clearDebugData: () => {
    sessionStorage.removeItem('openai-debug-payload');
    sessionStorage.removeItem('openai-debug-response');
    sessionStorage.removeItem('openai-debug-error');
    sessionStorage.removeItem('openai-debug-timestamp');
    logger.log('🐛 Debug: All debug data cleared');
  },

  // Trigger debug modal programmatically
  triggerDebugModal: () => {
    const event = new CustomEvent('open-debug-modal');
    window.dispatchEvent(event);
  }
};